<template>
  <div>
    <RequestTypeCardSearch
      :request-types="requestTypes"
      @search="updateTabRequests($event, requestTypesFiltered)"
      @expand="() => (allCollapsed = false)"
    />
    <div class="columns">
      <div class="column"></div>
      <div class="column is-4 has-text-right">
        <b-button
          v-if="allCollapsed"
          class="is-secondary is-light is-border-cornflowerblue"
          @click="switchCollapse"
          icon-left="plus-circle"
        >
          Expandir todas las solicitudes
        </b-button>
        <b-button
          v-else-if="!allCollapsed"
          class="is-warning is-light is-border-darkgoldenrod"
          @click="switchCollapse"
          icon-left="minus-circle"
        >
          Reducir todas las solicitudes
        </b-button>
      </div>
    </div>

    <div class="columns is-multiline">
      <div
        :class="`column ${size}`"
        v-for="(requestType, index) in this.requestTypesFiltered"
        :key="index"
      >
        <b-collapse
          :open="!allCollapsed"
          :class="`card card-hover-animation custom-border ${borderColor}`"
          animation="slide"
        >
          <template #trigger="props">
            <div class="card-header">
              <p
                :class="`card-header-title ${titleTextColor} has-text-left`"
                style="font-size: 1.2em"
              >
                <b-icon
                  class="mr-3 pr-2"
                  icon="file-alt"
                  pack="far"
                  size="is-large"
                ></b-icon>
                {{ requestType.real_name }}
              </p>
              <a class="card-header-icon">
                <b-icon
                  :class="titleTextColor"
                  :icon="props.open ? 'minus-circle' : 'plus-circle'"
                  size="is-medium"
                ></b-icon>
              </a>
            </div>
          </template>
          <div :class="`card-content ${borderTopContentColor}`">
            <div class="content">
              <p
                class="has-text-black"
                v-html="replaceNewlines(requestType.long_description)"
              />
              <div class="has-text-right">
                <b-button
                  icon-left="paper-plane"
                  :type="buttonType"
                  @click="redirect(requestType.id)"
                >
                  Iniciar Solicitud
                </b-button>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import RequestTypeCardSearch from "./RequestTypeCardSearch.vue";
export default {
  components: {
    RequestTypeCardSearch,
  },
  props: {
    requestTypes: Array,
    titleTextColor: String,
    backgroundColor: String,
    borderColor: String,
    buttonType: String,
    borderTopContentColor: String,
    size: {
      type: String,
      default: "is-6",
    },
  },
  data() {
    return {
      allCollapsed: true,
      requestTypesFiltered: [],
    };
  },
  methods: {
    redirect(requestTypeId) {
      window.open(`/requests/new/${requestTypeId}`, "_blank");
    },
    switchCollapse() {
      this.allCollapsed = !this.allCollapsed;
    },
    updateTabRequests(requestsSource, requestsDest) {
      requestsDest.splice(0, requestsDest.length, ...requestsSource);
    },
    replaceNewlines(text) {
      if (!text) return "";
      return text.replace(/\n/g, "<div class='my-2'></div>");
    },
  },
};
</script>
<style scoped>
.card-header {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  transition: background-color 0.2s ease-in-out;
}

.card-content {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.card-header-title {
  height: 6em;
}

.card-hover-animation {
  transition: transform 0.2s ease-in-out;
}

.card-hover-animation:hover {
  transform: scale(1.05);
}

.is-border-gcc {
  border: 2px solid #6356a1 !important;
  border-radius: 0.3rem;
}
</style>
